import { FC, MouseEventHandler } from 'react'
import cn from 'classnames'
import { QAMarked } from 'interfaces/component'

type TextButtonSize =
  | 'small'
  | 'regular'
  | 'large'

export type TextButtonTheme =
  | 'gray'
  | 'white'
  | 'lowercase'

type TextButtonsProps = QAMarked & {
  size?: TextButtonSize
  theme?: TextButtonTheme
  disabled?: boolean
  submit?: boolean
  onClick?: MouseEventHandler<HTMLButtonElement>
  className?: string
}

const TextButton: FC<TextButtonsProps> = (props) => {
  const {
    children,
    disabled,
    submit,
    size,
    theme,
    onClick,
    qaType,
    qaMarker,
    className,
  } = props

  const buttonType = submit ? 'submit' : 'button'

  const classNames = cn('textButton', className, {
    textButtonSmall: size === 'small',
    textButtonRegular: size === 'regular',
    textButtonLarge: size === 'large',
    textButtonGray: theme === 'gray',
    textButtonWhite: theme === 'white',
    textButtonLowercase: theme === 'lowercase',
  })

  return (
    <button
      data-qa-type={ qaType }
      data-qa-marker={ qaMarker }
      className={ classNames }
      type={ buttonType }
      disabled={ disabled }
      onClick={ onClick }
    >
      { children }
    </button>
  )
}

TextButton.defaultProps = {
  disabled: false,
  submit: false,
  size: 'small',
}

export default TextButton
